import { css } from "@obby/components";
export const styles = {
  blogPage: css({
    paddingTop: "90px",
    backgroundColor: "$white !important",
    fontFamily: "$foundersGrotesk",
    overflow: "hidden",

    ul: {
      paddingLeft: "1.2rem"
    }
  }),

  blogPageHeader: css({
    "@sm": {
      padding: "24px 5vw"
    },
    "@md": {
      padding: "24px 11vw"
    },
    "@bp4": {
      padding: "24px 170px"
    }
  }),

  headerTitle: css({
    h1: {
      fontSize: "2rem",
      paddingBottom: "$12",

      "@sm": {
        fontSize: "4rem"
      }
    },

    p: {
      fontSize: "1.2rem",
      filter: "opacity(0.7)"
    }
  }),

  headerAuthor: css({
    display: "flex",
    borderTop: "1px solid #e4eaed",
    paddingTop: "1rem"
  }),

  headerAuthorContent: css({
    alignSelf: "center",
    marginLeft: "1rem",
    p: {
      marginBottom: "0"
    },

    "p:last-child": {
      filter: "opacity(0.6)"
    }
  }),

  headerAuthorImg: css({
    width: "50px",
    height: "50px",

    img: {
      maxWidth: "100%",
      borderRadius: "50%"
    }
  }),

  mainHeader: css({
    paddingBlock: "24px"
  }),

  mainHeaderContent: css({
    p: {
      fontSize: "1.2rem"
    },

    "@sm": {
      padding: "$24 5vw"
    },
    "@md": {
      padding: "$24 11vw"
    },
    "@bp4": {
      paddingInline: "170px",
      paddingTop: "$24"
    }
  }),

  mainHeaderImg: css({
    textAlign: "center",
    img: {
      maxWidth: "1040px",
      width: "100%",
      height: "auto",
      maxHeight: "640px",
      objectFit: "cover"
    }
  }),

  section: css({
    marginTop: "2.5rem",
    p: {
      fontSize: "1.2rem"
    },

    ".beacon": {
      top: "-120px",
      "@md": { top: "-150px" }
    },

    "@sm": {
      padding: "0 5vw",
      marginTop: "$46"
    },
    "@md": {
      padding: "0 11vw"
    },
    "@bp4": {
      paddingInline: "170px"
    }
  }),

  sectionTitle: css({
    fontSize: "1.5rem !important",
    fontWeight: "500"
  }),

  sectionImg: css({
    marginBottom: "$24",
    img: {
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      objectFit: "cover"
    }
  }),

  sectionButton: css({
    textAlign: "center",
    paddingTop: "24px",
    paddingBottom: "2.5rem",
    borderBottom: "1px solid #e4eaed",

    "@sm": {
      paddingBottom: "$46"
    },

    ".rounded-button": {
      fontSize: "$16"
    }
  }),

  classesItems: css({}),

  classesItem: css({
    margin: "0.5em 0",
    fontSize: "1.2rem",
    a: {
      color: "#212529",
      fontWeight: "400",

      "&:hover": {
        transition: ".3s ease",
        color: "#3eb0ef",
        textDecoration: "none"
      }
    }
  }),

  classesTitle: css({
    fontWeight: "500"
  }),

  advice: css({
    marginTop: "2.5rem",
    p: {
      fontSize: "1.2rem"
    },

    "@sm": {
      padding: "0 5vw",
      marginTop: "$46"
    },
    "@md": {
      padding: "0 11vw"
    },
    "@bp4": {
      paddingInline: "170px"
    }
  }),

  blogLinks: css({
    p: {
      fontSize: "1.2rem"
    },
    paddingBottom: "2rem",
    "@sm": {
      padding: "0 5vw 5rem"
    },
    "@md": {
      padding: "0 11vw 5rem"
    },
    "@bp4": {
      paddingInline: "170px",
      paddingBottom: "5rem"
    }
  })
};
